import queryString from 'query-string'
import api from '@utils/api'
import {$http} from '@utils'

export default {
    namespaced: true,
    actions:{
        async getArticleDetail({ commit }, param ) {
            const res = await $http.get(`${api.article}/api/v1/article/detail?${queryString.stringify({
                ...param,
                company_id: 1, // 案例分享新增业务类型
                _business_tag: 'businessportal'
            })}`)
            return res
        },
    }
}
